(function($)
{
    $.extend(true, orion, {
        api: {
            cart: {}
        }
    });

    var
        api = orion.api.cart,
        uri = '/api-cart';

    function read()
    {
        var
            promise = $.ajax(uri, {
                'method': 'GET'
            });

        return promise;
    }

    function readItems(skip, take, field, dir)
    {
        var promise = $.ajax(uri + '/items', {
            'method': 'GET',
            'data': {
                'skip': skip,
                'take': take,
                'sort': [{
                    'field': field,
                    'dir': dir
                }]
            },
        });

        return promise;
    }

    api.read = read;
    api.readItems = readItems;
})(jQuery);
